import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { initializeApp } from 'firebase/app';
import configureStore from '@/redux/configureStore';
import App from './App';

const store = configureStore();
const firebaseConfig = {
  apiKey: 'AIzaSyDJd9GCEFkOorcWBvy4B53SpcNVjWwCziM',
  authDomain: 'open-banking-directory.firebaseapp.com',
  databaseURL: 'https://open-banking-directory.firebaseio.com',
  projectId: 'open-banking-directory',
  storageBucket: 'open-banking-directory.appspot.com',
  messagingSenderId: '224444540521',
  appId: '1:224444540521:web:9ff822c5c56f85d17b24f8',
  measurementId: 'G-46T7E4QZ8D',
};
initializeApp(firebaseConfig);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
